// src/security/Permitido.jsx
import React from 'react';
import { usePermissao } from './usePermissao';

/**
 * Renderiza os filhos só com a capacidade `cap` (ver capacidades.js). Sem ela,
 * renderiza o `fallback` — um aviso de recurso bloqueado, por exemplo — ou nada.
 */
export default function Permitido({ cap, fallback = null, children }) {
    const { pode } = usePermissao();
    return <>{pode(cap) ? children : fallback}</>;
}
